import Utils from '../../../utils/utils';
export default {
  render: function render(self) {
    var _self$params = self.params,
        sliderLabel = _self$params.sliderLabel,
        sliderValue = _self$params.sliderValue,
        sliderValueEditable = _self$params.sliderValueEditable,
        brightnessLabelText = _self$params.brightnessLabelText;
    return "\n      <div class=\"color-picker-module color-picker-module-brightness-slider\">\n        <div class=\"color-picker-slider-wrap\">\n          ".concat(sliderLabel ? "\n            <div class=\"color-picker-slider-label\">".concat(brightnessLabelText, "</div>\n          ") : '', "\n          <div class=\"range-slider color-picker-slider color-picker-slider-brightness\"></div>\n          ").concat(sliderValue ? "\n            <div class=\"color-picker-slider-value\">\n              ".concat(sliderValueEditable ? "\n                <input type=\"number\" step=\"0.1\" min=\"0\" max=\"100\" class=\"color-picker-value-brightness\">\n              " : "\n                <span class=\"color-picker-value-brightness\"></span>\n              ", "\n            </div>\n          ") : '', "\n        </div>\n      </div>\n    ");
  },
  init: function init(self) {
    self.brightnessRangeSlider = self.app.range.create({
      el: self.$el.find('.color-picker-slider-brightness'),
      min: 0,
      max: 1,
      step: 0.001,
      value: 0,
      on: {
        change: function change(range, value) {
          var b = Math.floor(value * 1000) / 1000;
          self.setValue({
            hsb: [self.value.hsb[0], self.value.hsb[1], b]
          });
        }
      }
    });
  },
  update: function update(self) {
    var value = self.value,
        app = self.app;
    var _self$params2 = self.params,
        sliderValue = _self$params2.sliderValue,
        sliderValueEditable = _self$params2.sliderValueEditable;
    var hsb = value.hsb;
    self.brightnessRangeSlider.value = hsb[2];
    self.brightnessRangeSlider.layout();
    var hslCurrent = Utils.colorHsbToHsl(hsb[0], hsb[1], hsb[2]);
    var hslLeft = Utils.colorHsbToHsl(hsb[0], hsb[1], 0);
    var hslRight = Utils.colorHsbToHsl(hsb[0], hsb[1], 1);
    self.brightnessRangeSlider.$el[0].style.setProperty('--f7-range-knob-color', "hsl(".concat(hslCurrent[0], ", ").concat(hslCurrent[1] * 100, "%, ").concat(hslCurrent[2] * 100, "%)"));
    self.brightnessRangeSlider.$el.find('.range-bar').css('background-image', "linear-gradient(".concat(app.rtl ? 'to left' : 'to right', ", hsl(").concat(hslLeft[0], ", ").concat(hslLeft[1] * 100, "%, ").concat(hslLeft[2] * 100, "%), hsl(").concat(hslRight[0], ", ").concat(hslRight[1] * 100, "%, ").concat(hslRight[2] * 100, "%))"));

    if (sliderValue && sliderValueEditable) {
      self.$el.find('input.color-picker-value-brightness').val("".concat(hsb[2] * 1000 / 10));
    } else if (sliderValue) {
      self.$el.find('span.color-picker-value-brightness').text("".concat(hsb[2] * 1000 / 10));
    }
  },
  destroy: function destroy(self) {
    if (self.brightnessRangeSlider && self.brightnessRangeSlider.destroy) {
      self.brightnessRangeSlider.destroy();
    }

    delete self.brightnessRangeSlider;
  }
};